<template>
  <div class="SetFlag">
    <el-dialog
      :title="'请设定今日目标(' + date1 + ')'"
      :visible.sync="dialogVisible"
      width="25%"
      :before-close="handleAddDrawerBeforeClose">
      <div>
        <i class="iconfont "></i>
        <span class="count">当前进度：本月累计
          <span style="color: red">{{leftAlert.monthDays}}</span> 天，剩余
          <span style="color: red">{{leftAlert.leftDays}}</span> 天，按目前进度，云上今天必须做
          <span style="color: red">{{leftAlert.avgClouds}}</span> 个，云上总计
          <span style="color: red">{{parseInt(leftAlert.leftCloud) >= 0 ? ('还差 ' + leftAlert.leftCloud) : ('超额 ' + Math.abs(leftAlert.leftCloud))}}</span> 个，套餐今天必须做
          <span style="color: red">{{leftAlert.avgCombos}}</span> 个，套餐总计还差
          <span style="color: red">{{parseInt(leftAlert.leftCombo) >= 0 ? ('还差 ' + leftAlert.leftCombo) : ('超额 ' + Math.abs(leftAlert.leftCombo))}}</span> 个，才能完成本月目标。</span>
      </div>
      <div class="contents">
        <el-row  class="mb-10">
          <el-col :span="4" class="m-label">云上</el-col>
          <el-col :span="20">
            <el-input type="number" v-model="target_cloud" size="small" placeholder="输入云上数量" />
          </el-col>
        </el-row>
        <el-row  class="mb-10">
          <el-col :span="4" class="m-label">套餐</el-col>
          <el-col :span="20">
            <el-input type="number"  v-model="target_combo" size="small" placeholder="输入套餐数量" />
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button v-if="false" size="mini" @click="HandleDialogVisibleClose">取 消</el-button>
    <el-button size="mini" type="primary" @click="HandleDialogVisible">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SetFlag',
  data () {
    return {
      dialogVisible: true,
      target_cloud: '',
      target_combo: '',
      status: false
    }
  },
  props: {
    date1: String,
    leftAlert: Object
  },
  mounted () {},
  methods: {
    HandleDialogVisible () {
      if (!this.target_cloud) {
        this.$message.error('请输入云上数量')
        return
      }
      if (!this.target_combo) {
        this.$message.error('请输入套餐数量')
        return
      }
      if (this.target_cloud === '0') {
        this.$message.error('云上数量不能为0')
        return
      }
      if (this.target_combo === '0') {
        this.$message.error('套餐数量不能为0')
        return
      }
      if (parseInt(this.target_cloud) < 0) {
        this.$message.error('云上数量不能负数')
        return
      }
      if (parseInt(this.target_combo) < 0) {
        this.$message.error('套餐数量不能负数')
        return
      }
      this.$axios.post('/api/target/set_target', {
        target_cloud: this.target_cloud,
        target_combo: this.target_combo
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.dialogVisible = data.data.status ? this.status : true
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleAddDrawerBeforeClose (done) {
      // this.$confirm('确认关闭?')
      //   .then(_ => {
      //     this.clearAddData()
      //     done()
      //   })
      //   .catch(_ => {})
    },
    clearAddData () {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .SetFlag
    marginLeft()
    position absolute
    left 0
    right 0
    top 0
    bottom 0
    margin 0 auto
  .mb-10
    margin-bottom: .2rem
    margin-top: 0.4rem;
  .m-label
    line-height: .64rem
  .top_hint
    height .8rem
    line-height .8rem
    background #ECF4FF
    span
      color: #5787FF
</style>



// WEBPACK FOOTER //
// src/common/SetFlag.vue